import * as Yup from 'yup'

export const createKYCPackFormValidationSchema = () => {
    return Yup.object().shape({
        recipientEmailAddress: Yup.string().required('Recipient email address is required'),
        recipientName: Yup.string().required('Recipient name is required'),
        includeCertificate: Yup.boolean().notRequired(),
        documents: Yup.boolean().notRequired()
            .when(['identityDocument', 'selfie', 'proofOfAddress'], {
                is: (identityDocument: boolean, selfie: boolean, proofOfAddress: boolean) => !identityDocument && !selfie && !proofOfAddress,
                then: Yup.boolean().required('At least one document is required.')
            }),
    })
}